/**
 * Returns true for Safari on desktop and iOS Safari.
 * Excludes Chrome, Chromium, Chrome iOS (CriOS), Firefox iOS (FxiOS), and Edge iOS.
 */
export function isSafariBrowser() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  return /safari/i.test(ua) && !/chrome|chromium|crios|fxios|edgios/i.test(ua);
}

/** Evaluated once at module load — user agent never changes during a session. */
export const IS_SAFARI = isSafariBrowser();

/**
 * Detect if the app is running inside a known social in-app browser (Instagram, Facebook, etc.).
 * We intentionally DO NOT try to detect generic iOS WebViews (WKWebView), because that
 * causes false positives on real Safari and other full browsers, leading to blank pages.
 */
export function isInAppBrowser() {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || navigator.vendor || window.opera || '';

  // Only detect explicit social in-app browsers; avoid generic WebView heuristics.
  return /Instagram|FBAN|FBAV|FB_IAB|FB4A|Twitter|LinkedInApp|Line/i.test(ua);
}

/**
 * Returns the name of the in-app browser, or null if not in a known in-app browser.
 * Useful for showing app-specific instructions (e.g. "Instagram → ⋯ → Open in Safari").
 */
export function getInAppBrowserName() {
  if (typeof navigator === 'undefined') return null;

  const ua = navigator.userAgent || navigator.vendor || window.opera || '';

  if (/Instagram/i.test(ua)) return 'Instagram';
  if (/FBAN|FBAV|FB_IAB|FB4A/i.test(ua)) return 'Facebook';
  if (/Twitter/i.test(ua)) return 'Twitter';
  if (/LinkedInApp/i.test(ua)) return 'LinkedIn';
  if (/Line/i.test(ua)) return 'Line';

  return null;
}
